import { useTranslation } from 'react-i18next';

export const useGetShowsAboutInfo = () => {
    const { t } = useTranslation();

    return [
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/leopard.mp4',
            id: '01',
            title: t('danceShow.leopard.title'),
            info: 'danceShow.leopard.info',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/leopardThumbnail+1.webp',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/retro.mp4',
            id: '02',
            title: t('danceShow.retro.title'),
            info: 'danceShow.retro.info',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/retroThubnail.jpeg',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Red.mp4',
            id: '1',
            title: t('danceShow.redShow.title'),
            info: 'danceShow.redShow.info',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/redDanceThumb.jpg',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/Black.mp4',
            id: '2',
            title: t('danceShow.blackShow.title'),
            info: 'danceShow.blackShow.info',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/blackDanceThumb.jpg',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/discoShow.mp4',
            id: '3',
            title: t('danceShow.discoShow.title'),
            info: 'danceShow.discoShow.info',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/discoDanceThumb.jpg',
        },
        {
            url: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/goldenBeats.mp4',
            id: '4',
            title: t('danceShow.goldenBeatsShow.title'),
            info: 'danceShow.goldenBeatsShow.info',
            thumbnailSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/videos/goldenBeatsThumb.jpg',
        },
    ];
};
